import React from 'react';
import { useNavigate } from 'react-router-dom';
import EmptyState from '../common/EmptyState';
import Button from '../common/Button';
import { ShoppingCartIcon } from '../icons/Icons';

const EmptyCart = () => {
  const navigate = useNavigate();

  return (
    <EmptyState
      icon={<ShoppingCartIcon size={64} />}
      title="Your cart is empty"
      description="Add items to your cart to see them here"
      action={
        <Button 
          variant="primary"
          size="md"
          onClick={() => navigate('/products')}
        >
          Continue Shopping
        </Button>
      }
    />
  );
};

export default EmptyCart;